import script from "./AddEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEvent.vue?vue&type=script&setup=true&lang=js"

import "./AddEvent.vue?vue&type=style&index=0&id=672b62d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672b62d8"]])

export default __exports__